module.exports = __webpack_public_path__ + "static/media/pedders-no-image.951c4ac4.webp";